// redux
import { createStore, applyMiddleware } from "redux"
import thunk from "redux-thunk"
// app
import reducer from "./reducer.js"


const store = createStore(
    reducer,
    {},
    applyMiddleware(
        thunk
    )
)

export default store


/** WEBPACK FOOTER **
 ** ./src/store.js
 **/